define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntitySeqIdKeyDomain = void 0;
    class EntitySeqIdKeyDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: EntitySeqIdKeyDomain.FacilityAssetBarcode, value: "Facility Asset Barcode" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[EntitySeqIdKeyDomain.FacilityAssetBarcode] = 0;
                this.ValueIndex = {};
                this.ValueIndex["Facility Asset Barcode"] = 0;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.EntitySeqIdKeyDomain = EntitySeqIdKeyDomain;
    Object.defineProperty(EntitySeqIdKeyDomain, "FacilityAssetBarcode", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(EntitySeqIdKeyDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
